<template>
  <router-link :to="{ name: 'customer', params: { id: prospect.id } }">
    <ul>
      <li><!--{{prospect.decoded_civility}}:-->{{prospect.name}}</li>
      <li class="main_representative" v-if="prospect.main_representative">{{prospect.main_representative.first_name}} {{prospect.main_representative.last_name}} <span>({{prospect.main_representative.decoded_representative_quality}})</span></li>
    </ul>
  </router-link>
</template>

<style lang="scss" scoped>
  a {
    color: #575757;
    background: #f8f8f8;
    margin-bottom: 2px;
    display: flex;
    align-items: center;
    transition: background 0.24s ease-in-out !important;
    &:hover {
      background: #fff;
    }
  }
  ul {
    display:flex;
    flex-direction:column;
    justify-content: center;
    padding: 7px 0 7px 10px;
    position:relative;
    margin: 0;
    min-height: 55px;
    li {
      line-height: 1rem;
      font-weight: 600;
      font-size: 16px;
      text-transform: uppercase;
    }
  }
  li.main_representative {
    font-size: 12px;
    span {
      text-transform: initial;
    }
  }
</style>

<script type="text/babel">

  export default {
    name: "ProspectsRecallsItem",

    props:['prospect'],

    data() {
      return {}
    },
  }
</script>



// WEBPACK FOOTER //
// client/components/Dashboard/ProspectsRecalls/ProspectsRecallsItem.vue